<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status" class="dialog-container"
      scrollable persistent max-width="500px">

      <v-card v-if="!compare_modal&&!err_modal">

          <!-- Title -->
          <v-card-title class="card-title">

            <div class="card-title-header">
              <div class="card-title-title">
                {{ $t('import_files.import_files') }}
              </div>
              <div v-if="mode == 0">
                {{ processed_files_length }} / {{ files_length }}
              </div>
              <div v-else>
                <span>{{ files_length }} {{ $t('import_files.files') }}</span>
                <span>{{ docs_array.length }} {{ $t('import_files.documents') }}</span>
                <span v-if="mode==3&&(dup_docs.length)">
                  ({{ dup_docs.length }}
                  {{ $t('import_files.duplicates') }})
                </span>
              </div>
            </div>

            <div class="card-title-contents">
              <span class="progress" v-if="mode<3&&!error">
                <div>파일을 읽고 있습니다...</div>
                <div>
                  <v-progress-circular
                  :width="1"
                  :size="50"
                  indeterminate
                  color="primary"/>
                </div>

                <!-- <span v-if="mode==0">
                  <v-progress-circular
                  :width="1"
                  :size="16"
                  indeterminate
                  color="primary"/>
                </span>
                <v-icon small color="success" v-else>mdi-checkbox-marked-circle</v-icon>
                <span>{{ $t('import_files.prepare') }}</span>

                <v-icon class="arrow" small>mdi-play</v-icon>

                <span v-if="mode==1">
                  <v-progress-circular
                  :width="1"
                  :size="16"
                  indeterminate
                  color="primary"/>
                </span>
                <v-icon small color="success" v-else-if="mode>1">mdi-checkbox-marked-circle</v-icon>
                <v-icon small v-else>mdi-checkbox-marked-circle</v-icon>
                <span>{{ $t('import_files.check') }}</span>

                <v-icon small class="arrow">mdi-play</v-icon>

                <span v-if="mode==2">
                  <v-progress-circular
                  :width="1"
                  :size="16"
                  indeterminate
                  color="primary"/>
                </span>
                <v-icon small color="success" v-else-if="mode>2">mdi-checkbox-marked-circle</v-icon>
                <v-icon small v-else>mdi-checkbox-marked-circle</v-icon>
                <span>{{ $t('import_files.upload') }}</span> -->
              </span>

              <div v-if="mode==3">
                <v-card class="point-element" @click="compare()"
                  v-if="!!Object.keys(compares).length">
                  <v-card-text class="compare-card">
                    <div class="compare-card-icon">
                      <v-icon color="warning" :size="24">mdi-alert-circle</v-icon>
                    </div>
                    <div class="compare-card-text">
                      <div class="compare-card-text-title">
                        {{ $t('import_files.improve') }}
                      </div>
                      <div>다른 사용자가 입력한 서지정보와 유사한 도큐먼트가 있습니다.</div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <div v-if="mode==3" class="list-title">
                <span class="highlight">
                  {{ $t('import_files.document_list') }} [{{ docs_preview.length }}]
                </span>
                <span class="list-notice">
                  <!-- <div>
                    <span><v-icon small>mdi-checkbox-blank-circle-outline</v-icon></span>
                    <span>이미 프로젝트에 포함</span>
                  </div>
                  <div>
                    <span><v-icon small>mdi-checkbox-blank-circle-outline</v-icon></span>
                    <span>도큐먼트 정보 확인 필요</span>
                  </div>
                  <div>
                    <span><v-icon small>mdi-checkbox-blank-circle-outline</v-icon></span>
                    <span>기타</span>
                  </div> -->
                  <!-- <span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="carolina_blue" v-on="on">mdi-alert-circle</v-icon>
                      </template>
                      <span v-if="route_mode=='docs'">
                        {{ $t('import_files.already_in_project') }}
                      </span>
                      <span v-else-if="route_mode=='refs'">
                        {{ $t('import_files.already_in_document') }}
                      </span>
                    </v-tooltip>
                    <span>{{ ins.length }}</span>
                  </span>
                  <span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="warning" v-on="on">mdi-alert-circle</v-icon>
                      </template>
                      <span>{{ $t('import_files.improve') }}</span>
                    </v-tooltip>
                    <span>{{ compares.length }}</span>
                  </span> -->
                </span> 
              </div>
            </div>
          </v-card-title>

          <v-card-text class="card-text">
            <div class="card-text-contents">
              <div v-if="mode==3" class="add-list">
                <span class="all-icon" @click="allSelect()">
                  <v-icon v-if="all_selected" size="18">mdi-checkbox-marked</v-icon>
                  <v-icon v-else-if="part_selected" size="18">mdi-minus-box</v-icon>
                  <v-icon v-else size="18">mdi-checkbox-blank-outline</v-icon>
                  <v-label>{{ $t('import_files.select_all') }}</v-label>
                </span>
              </div>
              <div v-if="mode==3">
                <div v-for="(doc, index) in docs_preview"
                  :key="index" class="add-list">
                  <v-checkbox
                    :value="doc.key"
                    v-model="checked_docs"
                    row
                    color="gray"
                    hide-details>
                    <template v-slot:label>
                      <div>
                        <span>{{ doc.authors_iso690 }}</span>
                        <span>({{ doc.date }})</span>
                        <span>{{ doc.title }}</span>
                        <span v-if="doc.compare" class="point-element"
                          @click="compare(doc.key)">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon small color="warning" v-on="on">mdi-alert-circle</v-icon>
                            </template>
                            <span>{{ $t('import_files.improve') }}</span>
                          </v-tooltip>
                        </span>
                        <span v-if="doc.in">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon small color="carolina_blue" v-on="on">mdi-alert-circle</v-icon>
                            </template>
                            <span v-if="route_mode=='docs'">
                              {{ $t('import_files.already_in_project') }}
                            </span>
                            <span v-if="route_mode=='clip'">
                              {{ $t('import_files.already_in_clip') }}
                            </span>
                            <span v-if="route_mode=='refs'">
                              {{ $t('import_files.already_in_document') }}
                            </span>
                          </v-tooltip>
                        </span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-text v-if="error">
            <div class="message-error">
              {{ error_message }}
            </div>
          </v-card-text>

          <v-card-actions class="footer">
            <div class="buttons">
              <v-btn small text @click="close()">
                {{ $t('import_files.stop') }}
              </v-btn>
              <v-btn v-if="mode==3"
                small depressed color="primary"
                :disabled="!checked_docs.length"
                @click="addDocs()">
                <span v-if="route_mode=='docs'">
                  {{ $t('import_files.add_to_project') }}
                </span>
                <span v-if="route_mode=='clip'">
                  {{ $t('import_files.add_to_document') }}
                </span>
                <span v-if="route_mode=='refs'">
                  {{ $t('import_files.add_to_document') }}
                </span>
              </v-btn>
            </div>

          </v-card-actions>

      </v-card>

      <!-- <v-card v-else-if="err_modal">
        <v-card-title class="card-title">
          <div class="card-title-header">
            <div class="card-title-title">
              필수정보가 누락된 도큐먼트가 있습니다.
            </div>
          </div>

          <div class="card-title-contents">
            <div>도큐먼트를 선택하고 '입력하기'를 누르시면 정보가 누락된 채로 입력됩니다. 
            '무시하기'를 누르시면 필수 정보가 있는 도큐먼트만 입력됩니다.</div>
            <div class="list-title">
              <span class="highlight">
                필수 정보가 누락된 도큐먼트 목록 [{{ err_docs.length }}]
              </span>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="card-text">
          <div class="card-text-contents">
            <div class="add-list">
              <span class="all-icon" @click="allErrSelect()">
                <v-icon v-if="all_err_selected" size="18">mdi-checkbox-marked</v-icon>
                <v-icon v-else-if="part_err_selected" size="18">mdi-minus-box</v-icon>
                <v-icon v-else size="18">mdi-checkbox-blank-outline</v-icon>
                <v-label>{{ $t('import_files.select_all') }}</v-label>
              </span>
            </div>
            <div>
              <div v-for="(doc, index) in err_docs" :key="index" class="add-list">
                <v-checkbox
                  :value="doc.key"
                  v-model="checked_err_docs"
                  row
                  color="gray"
                  hide-details>
                  <template v-slot:label>
                    <div>
                      <span>{{ doc.authors_iso690 }}</span>
                      <span>({{ doc.date }})</span>
                      <span>{{ doc.title }}</span>
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn @click="errModalClose()">무시하기</v-btn>
        </v-card-actions>
      </v-card> -->

      <improve-doc-info v-else
        :opened.sync="compare_modal"
        :compares.sync="selected_compares"
        :result.sync="compare_result">
      </improve-doc-info>

    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { enw_types, ris_types, bib_types, } from '../../../custom/model'
import { convertEnwToBT, convertRisToBT, convertBibToBT, returnDocDetail, addIso690, checkInputForm,
  checkDuplicate, checkRequiredField, createDocsArray, sortDocuments, } from '../../../custom/function'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      enw_type_model: enw_types,
      ris_type_model: ris_types,
      bib_type_model: bib_types,

      mode: 0,
      compare_modal: false,
      err_modal: false,

      error: false,
      error_message: "",
      
      format: null,
      ext: null,
      files: [],
      processed_files_length: 0,
      text: "",

      all_docs: [],
      fit_docs: [],
      dup_docs: [],
      err_docs: [],

      docs_array: [],
      check_result: [],

      docs_preview: [],
      compares: [],
      selected_compares: [],
      compare_result: null,

      checked_docs: [],
      all_selected: false,
      part_selected: false,

      is_in: true,
      is_compare: true,
      is_etc: true,

      // checked_err_docs: [],
      // all_err_selected: false,
      // part_err_selected: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      documents_in_proj: 'project/documents',
      referred_docs: 'document/referred_docs',
    }),

    route_mode() {
      if (this.$route.name == 'project' && !this.$route.query.doc) {
        return 'docs'
      } else if (this.$route.name == 'document' || !!this.$route.query.doc) {
        return 'refs'
      } else {
        return 'clip'
      }
    },

    files_length() {
      return this.files.length
    },
    
    ins() {
      return this.docs_preview.filter(v => v.in == true)
    },
    
  },

  watch: {
    dialog_status: {
      async handler(val) {
        if(val) {
          try {
            await this.$store.dispatch('auth/updateToken')
            this.initiate()
            this.format = this.$store.getters['input/format']
            this.text = this.$store.getters['input/text']
            this.files = this.$store.getters['input/files']
          } finally {
            this.readFiles()
          }
        }
      },
    },

    processed_files_length(val) {
      if (val == this.files_length && this.files_length>0) {
        // if (!this.err_docs.length) {
          this.checkDocuments()
          this.mode = 1
        // } else {
        //   this.err_modal = true
        // }
      }
    },

    checked_docs: {
      handler(val) {
        if (!!this.docs_preview.length) {
          if (this.checked_docs.length == this.docs_preview.length) {
            this.all_selected = true
            this.part_selected = false
          } 
          else if (!!this.checked_docs.length) {
            this.all_selected = false
            this.part_selected = true
          }
          else {
            this.all_selected = false
            this.part_selected = false
          }
        }
      },
      deep: true,
    },

    compare_result(val) {
      if (!!val.length) {
        let index = this.docs_preview.findIndex(v => v.key == val)
        this.$set(this.docs_preview[index], 'compare', false)
      }
    }
  },

  methods: {
    convertEnwToBT,
    convertRisToBT,
    convertBibToBT,
    checkDuplicate,
    checkRequiredField,
    createDocsArray,
    returnDocDetail,
    sortDocuments,
    addIso690,
    checkInputForm,

    close() {
      this.$store.commit('input/initialize')
      this.$emit('close')
    },

    initiate() {
      this.mode = 0

      this.error = false
      this.error_message = ""

      this.files = []
      this.processed_files_length = 0

      this.all_docs = []
      this.fit_docs = []
      this.dup_docs = []
      this.err_docs = []

      this.doc_array = []
      this.check_result = []
      
      this.docs_preview = []
      this.compares = []
      this.selected_compares = []
      this.compare_result = null

      this.checked_docs = []
      this.all_selected = false
      this.part_selected = false

      this.$store.commit('input/throwErrorImportFiles', null)
    },

    allSelect() {
      if (!this.all_selected) {
        this.checked_docs = this.docs_preview.map(v => v.key)
      } else {
        this.checked_docs = []
      }
    },

    // allErrSelect() {
    //   if (!this.all_err_selected) {
    //     this.checked_err_docs = this.err_docs.map(v => v.key)
    //   } else {
    //     this.checked_err_docs = []
    //   }
    // },

    // errModalClose() {
    //   this.err_modal = false
    //   this.checkDocuments()
    //   this.mode = 1
    // },

    readFileAsText(file, callback) {
      let reader = new FileReader()
      reader.onload = callback.bind(this)
      reader.readAsText(file)
    },

    readFiles() {
      this.ext = this.format
      if (this.format == 'files') {
        for (let i=0; i<this.files.length; i++) {
          this.ext = (this.files[i].name.split('.')).pop()
          switch(this.ext) {
            case 'enw':
              this.readFileAsText(this.files[i], this.readEnw)
              break;
            case 'ris':
              this.readFileAsText(this.files[i], this.readRis)
              break;
            case 'bib':
              this.readFileAsText(this.files[i], this.readBib)
            case 'bibtex':
              this.readFileAsText(this.files[i], this.readBib)
              break;
            case 'txt':
              this.readFileAsText(this.files[i], this.checkFileForm)
              break;
          }
        }
      } else {
        switch(this.ext) {
          case 'enw':
            this.readEnw(this.text)
            break;
          case 'ris':
            this.readRis(this.text)
            break;
          case 'bib':
            this.readBib(this.text)
            break;
        }
      }
    },

    checkFileForm(e) {
        let text = e.target.result
        let result = this.checkInputForm(text)
        // console.log('file_form', result)
        if (result == 'enw') {
          this.readEnw(e)
        } else if (result == 'ris') {
          this.readRis(e)
        } else if (result == 'bib') {
          this.readBib(e)
        } else {
          this.error = true
          this.error_message = '지원되지 않는 형식입니다. 다시 확인해주세요.'
        }
    },

    readEnw(f) {
      try {
        // Read a enw file as text
        let text = this.format=='files' ? f.target.result : f

        // Split text and create document array
        let docs_array = []
        docs_array = text.split('\n\n')
        docs_array = docs_array.map(el => el.trim())
        docs_array = docs_array.filter(el => el.length>3)

        // Split text and create field array
        for (let i=0; i<docs_array.length; i++) {
          let keys, values, type = ""
          let doc_arr = '\n' + docs_array[i]

          keys = doc_arr.match(/\n%\S\s/g);
          keys = keys.map(el => el.trim());
          values = doc_arr.split(/\n%\S\s/g).splice(1, keys.length)

          // Check the reference type
          if (keys.includes('%0')) {
            let index = keys.findIndex(ele => ele == '%0')
            let enw_type = values[index].toLowerCase().trim()
            type = !!this.enw_type_model[enw_type] ? this.enw_type_model[enw_type] : 'etc'
          } else {
            type = 'etc'
          }

          let result_obj = this.convertEnwToBT(type, keys, values)

          // Check duplicates
          this.all_docs.push(result_obj)
          let is_dup = this.checkDuplicate(result_obj, this.fit_docs)
          // let is_req = this.checkRequiredField(result_obj)
          if (is_dup) {
            this.dup_docs.push(result_obj)
          } else {
            this.fit_docs.push(result_obj)
          }
          // if (!is_dup&&is_req) {
          //   this.fit_docs.push(result_obj)
          // } else if (is_dup) {
          //   this.dup_docs.push(result_obj)
          // } else if (!is_req) {
          //   this.err_docs.push(result_obj)
          // }
        }
      } catch(e) {
          this.error = true
          this.error_message = this.$t('add_documents.error_fileform')
      } finally {
        if (this.format == 'files') {
          this.processed_files_length += 1
        } else {
          this.checkDocuments()
          this.mode == 1
        }
      }
    },

    readRis(f) {
      try {
        // Read a ris file as text
        let text = this.format=='files' ? f.target.result : f

        // Split text and create document array
        let docs_array = []
        docs_array = text.split('ER  -')
        docs_array = docs_array.map(el => el.trim())
        docs_array = docs_array.filter(el => el.length>3)

        // Split text and create field array
        for (let i=0; i<docs_array.length; i++) {
          let keys, values, type = ""
          let doc_arr = '\n' + docs_array[i]

          keys = doc_arr.match(/\n\S[A-Z0-9]/g)
          keys = keys.map(el => el.trim())
          values = doc_arr.split(/\n\S[A-Z0-9]/g).splice(1, keys.length)
          values = values.map((el) => {
            let arr = el.split('-')
            arr.shift()
            return arr.join('-').trim()
          })

          // Check the reference type
          if (keys.includes('TY')) {
            let index = keys.findIndex(ele => ele == 'TY')
            if (!!this.ris_type_model[values[index]]) {
              type = this.ris_type_model[values[index]]
            } else if (keys.includes('JO')) {
              if (keys.includes('TI') || keys.includes('T1')) {
                  type = 'journal_article'
              } else { type = 'journal' }
            }
          } else { type = 'etc' }
          
          let result_obj = this.convertRisToBT(type, keys, values)

          // Check duplicates
          this.all_docs.push(result_obj)
          let is_dup = this.checkDuplicate(result_obj, this.fit_docs)
          // let is_req = this.checkRequiredField(result_obj)
          if (is_dup) {
            this.dup_docs.push(result_obj)
          } else {
            this.fit_docs.push(result_obj)
          }
          // if (!is_dup&&is_req) {
          //   this.fit_docs.push(result_obj)
          // } else if (is_dup) {
          //   this.dup_docs.push(result_obj)
          // } else if (!is_req) {
          //   this.err_docs.push(result_obj)
          // }
        }
      } catch(e) {
        this.error = true
        this.error_message = this.$t('add_documents.error_fileform')
      } finally {
        if (this.format == 'files') {
          this.processed_files_length += 1
        } else {
          this.checkDocuments()
          this.mode == 1
        }
      }
    },

    readBib(f) {
      try {
        // Read a bib file as text
        let text = this.format=='files' ? f.target.result : f

        // Split text and create document array
        let docs_array = [], type_array = []
        text = '}' + text
        type_array = text.match(/}\s*@[a-zA-Z]+{/g)
        type_array = type_array.map(v => v.match(/@[a-zA-Z]+/)[0])
        docs_array = text.split(/}\s*@[a-zA-Z]+{/g)
        docs_array = docs_array.map(el => el.trim())
        docs_array.shift()

        // console.log('type_array', type_array, type_array.length)
        // console.log('docs_array', docs_array, docs_array.length)
          // Split text and create document array
        for (let i=0; i<docs_array.length; i++) {
          let fields = [], keys = [], values = []
          let type = type_array[i]
          let doc = docs_array[i]
          // console.log('type_old', type)

          keys = doc.match(/,\s*\S+\s*=/g)
          keys = keys.map(v => v.match(/[a-zA-Z]+/g)[0])
          values = doc.split(/,\s*\S+\s*=/g)
          values = values.map(el => el.trim().match(/[^{}"]+/g)[0])
          values.shift()

          // Check the reference type
          let bib_type = type_array[i]
          type = !!this.bib_type_model[type] ? 
            this.bib_type_model[type.toLowerCase()] : 'etc'
          keys.push('type')
          values.push(type)
          // console.log('type', type, 'keys', keys, 'values', values)
          
          let result_obj = this.convertBibToBT(type, keys, values)
          // console.log('result_obj', result_obj)

          // Check duplicates
          this.all_docs.push(result_obj)
          let is_dup = this.checkDuplicate(result_obj, this.fit_docs)
          // let is_req = this.checkRequiredField(result_obj)
          if (is_dup) {
            this.dup_docs.push(result_obj)
          } else {
            this.fit_docs.push(result_obj)
          }
          // if (!is_dup&&is_req) {
          //   this.fit_docs.push(result_obj)
          // } else if (is_dup) {
          //   this.dup_docs.push(result_obj)
          // } else if (!is_req) {
          //   this.err_docs.push(result_obj)
          // }
        }
      } catch(e) {
          this.error = true
          this.error_message = this.$t('add_documents.error_fileform')
      } finally {
        if (this.format == 'files') {
          this.processed_files_length += 1
        } else {
          this.checkDocuments()
          this.mode == 1
        }
      }
    },

    async checkDocuments() {
      this.docs_array = this.createDocsArray(this.fit_docs)
      try {
        await this.$store.dispatch('input/checkDocuments', {
          docs_array: this.docs_array,
          insert_new: true,
        })
      } catch(e) {
          this.error = true
          let error_code = !!e.response ? e.response.status : '000'
          this.error_message = error_code == 413 ?
            '제한 용량이 초과되었습니다. 더 적은 수의 도큐먼트로 다시 시도해주세요.' + "(" + error_code + ")":
            this.$t('add_documents.error_checking') + "(" + error_code + ")"
      } finally {
        if (!this.error) {
          this.check_result = this.$store.getters['input/check_result']
          this.$analytics.logEvent('click', { name: 'importFiles_btn_inputDocuments' })
          this.getDocsPreview()
        }
      }
    },

    // async inputDocuments() {
    //   this.mode = 2
    //   let docs_input = this.createDocsInput()
    //   if (!!docs_input) {
    //     try {
    //       await this.$store.dispatch('input/inputDocuments', docs_input)
    //     } catch(e) {
    //       this.error = true
    //       let error_code = e.response.status
    //       this.error_message = this.$t('add_documents.error_inputting') + "(" + error_code + ")"  
    //     } finally {
    //       if (!this.error) {
    //         let new_keys = Array.from(new Set(this.$store.getters['input/input_docs_new']))
    //         this.$analytics.logEvent('click', { name: 'importFiles_btn_inputDocuments' })
    //         this.getDocsPreview(new_keys)
    //       }
    //     }
    //   } else {
    //     this.getDocsPreview([])
    //   }
    // },

    // createDocsInput() {
    //   let docs_input = {}
    //   let docs_new = []

    //   let news = this.check_result.filter(el => {
    //     return el.result == 'new'
    //   })
    //   if (!!news.length) {
    //     for (let i=0; i<news.length; i++) {
    //       let src_number = news[i].src_number
    //       let doc = this.docs_array.find(v => v.source.src_number == src_number)
    //       docs_new.push(doc)
    //     }
    //     docs_input['docs_new'] = docs_new
    //     return docs_input
    //   } else {
    //     return null
    //   }
    // },

    // async getDocsPreview(new_keys) {
    //   let exist_keys, compare_keys, compare_arrs
      
    //   // get exist keys
    //   exist_keys = Array.from(
    //     new Set(this.check_result.filter(el => {
    //       return el.result == 'exist'
    //     }).map(v => v.data[0].doc_key)))
      
    //   // get compare keys
    //   try {
    //     compare_arrs = this.check_result.filter(el => {
    //       return el.result == 'compare'
    //     })
    //     compare_keys = Array.from(
    //       new Set(compare_arrs.map(v => v.data[0].doc_key)))
    //   } finally {
    //     if (!!compare_keys.length) {
    //       for (let i=0; i<compare_keys.length; i++ ){
    //         let key = compare_keys[i]
    //         let src_number = compare_arrs.find(v => 
    //           v.data[0].doc_key == key).src_number
    //         let user_doc = this.docs_array.find(v => v.source.src_number == src_number)
    //         this.compares.push({
    //           key: compare_arrs[i].data[0].doc_key,
    //           compare_keys: compare_arrs[i].data.map(v => v.doc_key),
    //           user_doc: user_doc, 
    //         })
    //       }
    //     }
    //   }

    //   let keys = exist_keys.concat(compare_keys, new_keys)
    //   keys = Array.from(new Set(keys))

    //   let docs = []
    //   for (let i=0; i<keys.length; i++) {
    //     let doc = {}
    //     let error = false
    //     try {
    //       await this.$store.dispatch('input/getNewDocument', keys[i])
    //     } catch(e) {
    //       this.$store.commit('error/setDialog', true)
    //       this.$store.commit('error/setErrorCode', e.response.status)
    //       error = true
    //     } finally {
    //       if (!error) {
    //         doc = this.$store.getters['input/new_document']
    //         doc = this.returnDocDetail(doc, doc.doc_type)
    //         doc['compare'] = compare_keys.includes(keys[i]) ? true : false
    //         if (this.route_mode=='docs') {
    //           doc['in'] = this.documents_in_proj.map(v=>v.key).includes(keys[i]) ? true : false
    //         } else if (this.route_mode=='refs') {
    //           doc['in'] = this.referred_docs.map(v=>v.key).includes(keys[i]) ? true : false
    //         }
    //         docs.push(doc)
    //       }
    //     }
    //   }
    //   this.docs_preview = this.sortDocuments(docs, 4)
    //   this.mode = 3
    // },

    getDocsPreview() {
      let compare_keys, compare_arrs
      // console.log('check_result', this.check_result)

      // get compare keys
      try {
        compare_arrs = this.check_result.filter(el => {
          return el.result == 'compare'
        })
        compare_keys = Array.from(
          new Set(compare_arrs.map(v => v.data[0].doc_key)))
      } finally {
        if (!!compare_keys.length) {
          for (let i=0; i<compare_keys.length; i++ ){
            let key = compare_keys[i]
            let src_number = compare_arrs.find(v => 
              v.data[0].doc_key == key).src_number
            let user_doc = this.docs_array.find(v => v.source.src_number == src_number)
            this.compares.push({
              key: compare_arrs[i].data[0].doc_key,
              compare_keys: compare_arrs[i].data.map(v => v.doc_key),
              user_doc: user_doc, 
            })
          }
        }
      }

      let docs = []
      for (let i=0; i<this.docs_array.length; i++) {
        let doc = this.docs_array[i].document
        let src_number = this.docs_array[i].source.src_number
        let r = this.check_result.filter(el => {
          return el.src_number == src_number
        })
        this.addIso690([doc]).then(res => doc = res[0])
        doc = this.returnDocDetail(doc, doc.doc_type)
        // console.log('r', r)
        let key = r[0].data[0].doc_key
        doc['key'] = key
        doc['compare'] = compare_keys.includes(key) ? true : false
        if (this.route_mode=='docs' || this.route_mode=='clip') {
          doc['in'] = this.documents_in_proj.map(v=>v.key).includes(key) ? true : false
        } else if (this.route_mode=='refs') {
          doc['in'] = this.referred_docs.map(v=>v.key).includes(key) ? true : false
        }
        docs.push(doc)
      }
      // console.log('docs', docs)
      this.docs_preview = this.sortDocuments(docs, 4)
      this.allSelect()
      this.mode = 3
    },

    compare(key) {
      if (!!key) {
        this.selected_compares = 
          [this.compares.find(v => v.key == key)]
      } else {
        this.selected_compares =
          this.compares
      }
      this.compare_modal = true
    },

    addDocs() {
      if (this.route_mode=='docs') {
        this.addDocuments(this.$route.params.id)
      } else if (this.route_mode == 'refs') {
        this.addReferences()
      } else if (this.route_mode == 'clip') {
        let clip_id = this.$store.getters['project/projects'].filter(v => v.mode == 9)[0].proj_id
        // console.log('clip_id', clip_id)
        this.addDocuments(clip_id)
      }
    },

    async addDocuments(proj_id) {
      let add_docs = this.checked_docs.filter(v => !(this.documents_in_proj.map(el => el.key).includes(v)))
      if (!!add_docs.length) {
        try {
          await this.$store.dispatch('project/addDocumentsToProject', {
            proj_id,
            documents: add_docs
          })
        } finally {
          let error = this.$store.getters['input/import_error_type']
          let error_code = this.$store.getters['error/error_code']
          if (error == 'add') {
            this.error = true
            this.error_message = "An error has occured adding documents(" + error_code + ")"
          } else {
            try {
              await this.$store.dispatch('project/getProject', {
                proj_id,
              })
            } finally {
              this.$analytics.logEvent('click', { name: 'importFiles_btn_addDocuments' })
              this.close()
            }
          }
        }
      } else {
        this.close()
      }
    },

    async addReferences() {
      let add_docs = this.checked_docs.filter(v => !(this.referred_docs.map(el => el.key).includes(v)))
      if (!!add_docs.length) {
        try {
          await this.$store.dispatch('input/addReferences', {
            proj_id: this.$route.params.id,
            doc_key: this.$route.query.doc,
            documents: add_docs
          })
        } finally {
          let error = this.$store.getters['input/import_error_type']
          let error_code = this.$store.getters['error/error_code']
          if (error == 'add') {
            this.error = true
            this.error_message = "An error has occured adding references(" + error_code + ")"
          } else {
            this.$analytics.logEvent('click', { name: 'importFiles_btn_addReferences' })
            this.close()
          }
        }
      } else {
        this.close()
      }
    },
  },
}
</script>

<style scoped>
  .card-title {
    display: flex;
    flex-direction: column;
  }

  .card-title-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.8rem;
    color: rgb(0, 0, 0, 0.54);
  }

  .card-title-title {
    font-size: 1.25rem;
    letter-spacing: -.25px;
    font-weight: 500;
    color: #2c3e50;
  }

  .card-title-contents {
    width: 100%;
    line-height: 160%;
    color: rgb(0, 0, 0, 0.54);
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    margin-top: 12px;
  }

  .card-text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .card-text-contents {
    display: flex;
    flex-direction: column;
  }

  .list-title {
    margin-top: 24px;
    font-size: 1rem;
    /* display: flex;
    justify-content: space-between; */
  }

  .list-notice {
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.54);
    /* margin-left: 12px; */
    margin-top: 6px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .list-notice > div {
    margin-left: 8px;
  }

  .add-list {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
  }

  .footer {
    display: flex;
    flex-direction: column;
  }

  .footer > div {
    width: 100%;
    display: flex;
    margin: 10px 0;
  }

  .footer > .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .point-element {
    cursor: pointer;
  }

  .compare-card {
    display: flex;
    flex-direction: row;
  }

  .compare-card-icon {
    margin-right: 10px;
  }

  .compare-card-text {
    font-size: 0.7rem;
  }

  .compare-card-text-title {
    font-size: 1rem;
    font-weight: 500;
    color: #2c3e50;
  }

  .highlight {
    color: #2c3e50;
  }

  .buttons > .v-btn {
    margin-left: 12px;
  }

  .v-input--selection-controls.v-input .v-label {
    font-size: 14px !important;
  }

  .all-icon > .v-label {
    cursor: pointer;
  }

  .all-icon > .v-icon {
    margin-right: 8px;
    cursor: pointer;
  }

  .progress {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  .progress > div{
    margin-top: 30px;
  }

  .arrow {
    margin-right: 5px;
    color: #818387;
  }
</style>


// WEBPACK FOOTER //
// src/components/modal/input/ImportFiles.vue